<template>
	<dl class="sideBar">
		<dt>
			<a href = "javascript:void(0)" class = "sidetitle" @click = "spreadList($event)">
				<div class = "sideIcon sideIcon1"></div>
				内容管理
				<div class = "sideTip"></div>
			</a>
		</dt>
		<dd>
			<ul class="sideList sideHide">
				<li>
					<a href="/contentList">文件列表</a>
				</li>
			</ul>
		</dd>
		<dt>
			<a href = "javascript:void(0)" class = "sidetitle" @click = "spreadList($event)" >
				<div class = "sideIcon sideIcon2"></div>
				账号管理
				<div class = "sideTip"></div>
			</a>
		</dt>
		<dd>
			<ul class="sideList sideHide">
				<li v-if="pass">
					<a href="/userList">账号列表</a>
				</li>
				<li>
					<a href="/groupList">分组管理</a>
				</li>
			</ul>
		</dd>
		<div class = "copy-text">
			© 2018 zhiyun-tech.com All rights reserved. <br/>
			 桂林智神信息技术有限公司 <br/>
			桂ICP备15010724号-1
		</div>
	</dl>
</template>

<script>
	export default {
		name: 'test',
		data() {
			return {
				pass:false
			}
		},
		created: function() {
			var _this = this;
			this.getLocalUser.permissions.forEach(function(e){
				if(e.permissionname=="账号管理"){
					_this.pass = true;
					return;
				}
			})
		},
		mounted: function() {
			var _this = this;
			
			$("dd").each(function(index){
				$(this).find(".sideList").css("height",$(this).find(".sideList>li").length*34+"px")
				$(this).find("li").each(function(index){
					if(_this.$route.name=="/"){
						$("dd").eq(0).find("li").eq(0).addClass("active")
						$("dd").eq(0).find(".sideList").removeClass("sideHide");
					}
					if($(this).children("a").attr("href")==("/"+_this.$route.name)){
						$(this).addClass("active")
						$(this).parents(".sideList").removeClass("sideHide");
					}
				})
				
			})
		},
		methods: {
			spreadList: function(event) {
				 let toggle = event.currentTarget;
				 let sideListNode = $(toggle).parent("dt").next("dd").find(".sideList");
				 if(sideListNode.hasClass("sideHide")){
				 	sideListNode.removeClass("sideHide");
				 }else{
				 	sideListNode.addClass("sideHide")
				 }
			}
		}

	}
</script>

<style scoped="scoped">
	@import url("../../../static/css/sideBar.css");
</style>


// WEBPACK FOOTER //
// src/components/comHtml/sideBar.vue